export default __webpack_public_path__ + "static/media/transact-add-purchase.154eb2d5.png";